import { ProfileFields } from "@/components/profile/ProfileFields";
import type { ProfileGateState as Gate } from "./useProfileGate";

/** Inline profile completion at registration — the same ProfileFields the
 *  Profile page uses. Location is shown and prefilled from the event. */
export function ProfileGate({ gate }: { gate: Gate }) {
  return (
    <div className="space-y-3 rounded-md border bg-muted/30 p-3">
      <p className="text-sm font-medium">Confirm your details to register</p>
      <ProfileFields value={gate.value} onChange={gate.patch} errors={gate.errors} />
    </div>
  );
}
